export function withScope(args: string[], scope?: string): string[] {
  return scope ? [...args, '--scope', scope] : args
}
